export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9234.90c6ab5b.jpg";